<template>
  <div v-show="isVMS && isShowVehicle" class="vehicle">
    <span class="vehicle_online">在线：{{ vehicleMap.onLineTotal }} 辆&emsp;</span>
    <a class="vehicle_off" :href="vehicleMap.offJumpUrl">
      运输车离线：{{ vehicleMap.carryCount }} 辆&emsp;行政车离线：{{ vehicleMap.executiveCount }} 辆 &emsp;市场车离线：{{ vehicleMap.marketCarCount }} 辆
    </a>
  </div>
</template>
<script>
import Vue from 'vue'
import { socketIo } from './socket'

let vmsSocket = null
const getProtocol = () => {
  return window.location.host === 'www.kye-erp.com' ? 'wss://wss-vms-push.kyslb.com:7777' : 'wss://vmsapi-uat.kyeapi.com:443'
}
const isJsonString = str => {
  try {
    if (typeof JSON.parse(str) === 'object') {
      return true
    }
  } catch (e) {
    return false
  }
  return false
}

export default {
  data() {
    return {
      isCreating: false,
      isVMS: false,
      vehicleTotalNum: 0,
      vehicleIdProperties: {},
      SOCKET_TYPE: 'MsgOfflineDetail',
      vehicleIdObj: {},
      vehicleMap: {
        offJumpUrl: '#/vms-equipment/device-info/list?tabIndex=2',
        onLineTotal: 0,
        offLineTotal: 0,
        carryCount: 0,
        executiveCount: 0,
        marketCarCount: 0,
      },
    }
  },
  beforeDestroy() {
    vmsSocket && vmsSocket.removeListener('getVehicleCount')
    vmsSocket && vmsSocket.close()
    vmsSocket = null
  },
  computed: {
    isShowVehicle() {
      const { onLineTotal, carryCount, executiveCount, marketCarCount, showFlag } = this.vehicleMap
      return !!(onLineTotal || carryCount || executiveCount || marketCarCount) && +showFlag === 1
    },
  },
  watch: {
    '$route.path'(path) {
      if (path.startsWith('/vms') || path.startsWith('/vcar') || path.startsWith('/kycar') || path.startsWith('/v-auto-parts')) {
        this.isVMS = true
        if (!this.isCreating && !vmsSocket) {
          this.isCreating = true
          socketIo(`${getProtocol()}`).then(socket => {
            this.isCreating = false
            Vue.prototype.vmsSocket = socket
            vmsSocket = socket
            vmsSocket.addListener('getVehicleCount', this.handleVehicleFn)
            this.getVehicleCount()
          })
        }
      } else {
        this.isVMS = false
      }
    },
  },
  methods: {
    handleVehicleFn(res) {
      if (!this.isVMS) return
      let data = isJsonString(res) ? JSON.parse(res) : JSON.parse('{}')
      if (data && data.type === this.SOCKET_TYPE) {
        let params = data.params || []
        let len = params.length
        let [n, i, j, k] = [0, 0, 0, 0] // j: 离线总车辆，i: 离线运输车, k: 离线市场车 ，j-i-k：离线行政车
        while (n < len) {
          let item = params[n]
          if (this.vehicleIdProperties[item.id]) {
            // t:类型(1:运输车，0:行政车, 2: 市场车)
            if (+item.t === 1) {
              i++ // 离线车辆
            } else if (+item.t === 2) {
              k++
            }
            j++ // 统计离线总车辆
          }
          n++
        }
        this.vehicleMap.onLineTotal = this.vehicleTotalNum - j
        this.vehicleMap.offLineTotal = j
        this.vehicleMap.carryCount = i
        this.vehicleMap.executiveCount = j - i - k
        this.vehicleMap.marketCarCount = k
      }
    },
    splitResult(data = []) {
      this.vehicleTotalNum = data.length || 0
      let i = 0
      while (i < this.vehicleTotalNum) {
        this.vehicleIdProperties[data[i]] = true
        this.vehicleIdObj[data[i]] = 0
        i++
      }
    },
    getVehicleCount() {
      this.$http('vms.transport.vehicle.selectVehicleIdList', {}, { axios: { headers: { 'X-menu-id': '2820215716730110' } } }).then((res = {}) => {
        if (!res.vehicleIds || !res.vehicleIds.length) return // 该用户无车管权限则 无须执行下面的语句
        this.vehicleMap.onLineTotal = res.onLineTotal || 0
        this.vehicleMap.offLineTotal = res.offLineTotal
        this.vehicleMap.carryCount = res.carryCount
        this.vehicleMap.executiveCount = res.executiveCount
        this.vehicleMap.marketCarCount = res.marketCarCount
        this.vehicleMap.showFlag = res.showFlag || 1
        this.splitResult(res.vehicleIds)
        /**
         * @params getVehicleCount string 自定义key 供socket找到 该回调函数
         * @params handeVehicleFn 回调函数
         * **/
        vmsSocket && vmsSocket.send('11|00')
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.vehicle {
  max-width: 500px;
  max-height: 50px;
  overflow: hidden;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/shared/home-modules/header/vms-vehicle-count.vue